<template>
	<modal class="bulk-return-status-modal" size="medium" @close="close">
		<div slot="header">
			<h3>
				<i class="material-icons">list_alt</i><b>Upload File</b>
			</h3>
		</div>
		<div slot="body">
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<label><b>File</b></label>
						<input
							type="file"
							name="receipt_file"
							class="input form-control form-control-narrow"
							accept=".xlsx"
							@change="selectFile"
						/>
					</div>
				</div>
			</div>
			<!-- Example -->
			<a
				:href="templateUrl"
				target="_blank"
			>
				Download Template Excel File
			</a>

			<!-- Result Table -->
			<div v-if="result">
				<hr	/>

				<table class="table table-minimal table-responsive mb-4">
					<tr>
						<td><span class="badge badge-success">Success</span></td>
						<td>:</td>
						<td>{{ result.success }}</td>
					</tr>
					<tr>
						<td><span class="badge badge-danger">Failed</span></td>
						<td>:</td>
						<td>{{ result.failed }}</td>
					</tr>
					<tr>
						<td><span class="badge badge-primary">Total Data</span></td>
						<td>:</td>
						<td>{{ result.total_rows }}</td>
					</tr>
				</table>

				<table class="table" v-if="result.failed_data.length > 0">
					<thead>
						<tr>
							<th width="30%">Order ID</th>
							<th width="70%">Error</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, idx) in result.failed_data" :key="idx">
							<td>{{ item.order_id }}</td>
							<td>{{ item.error_message }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div slot="footer">
			<button class="btn btn-light" @click="close">
				Cancel
			</button>
			<button
				class="btn btn-primary"
				:class="{ 'is-loading': isUploading }"
				:disabled="!file"
				@click="upload"
			>
				<i class="material-icons">cloud_upload</i>
				<span>Upload</span>
			</button>
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { updateBulkReturnStatus } from '@/api/submissions';

export default {
	components: {
		Modal,
	},
	data() {
		return {
			file: null,
			isUploading: false,
			result: null,
			templateUrl: 'https://cdn.ostock.id/templates/template-update-return-status.xlsx',
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		selectFile(event) {
			const target = event.target;
			const files = target.files;
			this.file = files[0];
		},
		upload() {
			this.isUploading = true;

			const formData = new FormData();
			const file = this.file;

			formData.append('file', file);

			const callback = (response) => {
				const result = response.data;
				this.result = result;
				this.isUploading = false;
				this.$emit('increment');
			};

			const errorCallback = () => {
				this.isUploading = false;
			};

			updateBulkReturnStatus(formData, callback, errorCallback);
		},
	},
};
</script>

<style scoped>
table.table-minimal {
	border-collapse: collapse;

	td, th {
		text-align: left;
		padding: 3px;
	}
}
</style>
